import React, { useState, useContext, useEffect } from 'react';
import { mdiCheckboxMarkedCircleOutline } from '@mdi/js';
import { useParams } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import { Then, Unless, When, If } from 'react-if';
import AlertMessage from '~/shared/components/alertMessage';
import api from '~/services/api';
import PrescriptionDataView from '../prescriptionDataView';
import { MainContext } from '~/context';
import {
  Container,
  TitleAcess,
  Form,
  Validate,
  InputContainer,
  Input,
  Label,
  ButtonForm,
} from './styles';
import validateHashOrigin from '~/utils';
import { setDocumentAuthorizationToken } from '~/utils/documentAuthorization';

const ValidateHome = () => {
  const [maskData, setMaskData] = useState('');

  const context = useContext(MainContext);
  const {
    showHome,
    setShowHome,
    validated,
    setPlataformValidation,
    inputValue,
    setInputValue,
    isAlertMessageOpen,
    setAlertMessageOpen,
    alertMessage,
    setAlertMessage,
    setLoginDisplay,
    setcaptchaValidation,
    captchaValidation,
    setButtonDisplay,
    setGoBackNewConsult,
    setValidated,
    setDataDocument,
    setAlertControlled,
  } = context;

  const params = useParams();

  useEffect(() => {
    setLoginDisplay(false);
  }, []);

  useEffect(() => {
    if (params.id) {
      setInputValue(params.id);
    }
  }, [params.id]);

  useEffect(() => {
    if (inputValue.length > 10) {
      setMaskData('****-****-****-****');
    } else {
      setMaskData('');
    }
  }, [inputValue, maskData]);

  function handleToken() {
    if (!captchaValidation) {
      setAlertMessage('Captcha inválido');
      setAlertMessageOpen(true);
    } else {
      api
        .get(`/validate/document/${validateHashOrigin(inputValue)}`)
        .then(({ data: responseData }) => {
          const data = responseData;
          if (!responseData.data || responseData.data.lenght === 0) {
            setAlertControlled(true);
          } else if (!responseData.data.some((r) => r.controlled)) {
            setAlertControlled(false);
          }
          setPlataformValidation(false);
          setShowHome(false);
          setDataDocument(data);
          setValidated(true);
          setGoBackNewConsult(false);
          setButtonDisplay(true);
          setDocumentAuthorizationToken(data?.token);
        })
        .catch((error) => {
          setAlertMessage(
            'Não foram encontrados documentos para o código enviado. \nPara maiores informações entre em contato pelo telefone (11) 2151-7690 ou pelo email einsteinconecta@einstein.br.'
          );
          setAlertMessageOpen(true);
          setShowHome(true);
        });
    }
  }

  return (
    <>
      <When condition={showHome}>
        <Container>
          <AlertMessage
            alert={isAlertMessageOpen}
            icon={mdiCheckboxMarkedCircleOutline}
            message={alertMessage}
            background={isAlertMessageOpen}
          />
          <TitleAcess>
            Para acessar a documentação digital, informe abaixo:
          </TitleAcess>
          <Form>
            <Validate>
              <InputContainer>
                <Label>CHAVE DE VALIDAÇÃO (OBRIGATÓRIO)</Label>
                <Input
                  mask={maskData}
                  value={inputValue}
                  maskChar=""
                  onChange={(event) => {
                    setInputValue(event.target.value.replace(/\.|-/g, ''));
                  }}
                />
              </InputContainer>
              <InputContainer>
                <Label>MARQUE ABAIXO PARA CONTINUAR</Label>
                <ReCAPTCHA
                  theme="light"
                  sitekey="6LfkxAcaAAAAAF9i2XPusmXh-NBRiwIRiyvqtYbh"
                  onChange={() => {
                    setcaptchaValidation(true);
                  }}
                />
              </InputContainer>
              <ButtonForm type="button" onClick={() => handleToken()}>
                PRÓXIMO
              </ButtonForm>
            </Validate>
          </Form>
        </Container>
      </When>
      <Unless condition={showHome}>
        <If condition={validated}>
          <Then>
            <PrescriptionDataView tokenRef={inputValue} />
          </Then>
        </If>
      </Unless>
    </>
  );
};

export default ValidateHome;
